module.exports = __webpack_public_path__ + "./static/img/icon-1.52ce3690d73c2f9053d1de45e64e4a80.png";


//////////////////
// WEBPACK FOOTER
// ./client/src/assets/img/join/icon-1.png
// module id = ./client/src/assets/img/join/icon-1.png
// module chunks = 0